export default {
	data() {
		return {
			isMenuOpen: false,
			isMobileVersion: false,
		};
	},
	mounted() {
		this.resize();
		if (this.$route.name === 'user-profile') {
			this.isMenuOpen = true;
		}
		window.addEventListener('resize', this.debounce(() => {
			this.resize();
		}));
	},
	methods: {
		resize() {
			this.isMobileVersion = false;
			if (document.documentElement.clientWidth < 559) this.isMobileVersion = true;
		},
		debounce(func) {
			let timer;
			return (event) => {
				if (timer) clearTimeout(timer);
				timer = setTimeout(func, 100, event);
			};
		},
		toggleOpenMenuMobile(value) {
			this.isMenuOpen = value;
		},
	},
};
